import { PATHS } from "../../constants/paths"
import { useDialog } from "../../context/DialogContext"
import { useAppDispatch, useAppSelector } from "../../store"
import { DepositDialog } from "../dialog/DepositDialog"
import { WithdrawalDialog } from "../dialog/WithdrawalDialog"
import { AccountMenu } from "./AccountMenu"
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward"
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"
import DashboardIcon from "@mui/icons-material/Dashboard"
import PeopleAltIcon from "@mui/icons-material/PeopleAlt"
import PaymentIcon from "@mui/icons-material/Payment"
import SyncIcon from "@mui/icons-material/Sync"
import { BorderColor, Home, Person } from "@mui/icons-material"
import { Drawer, useTheme } from "@mui/material"
import Box from "@mui/material/Box"
import Divider from "@mui/material/Divider"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import { styled } from "@mui/material/styles"
import React, { useState } from "react"
import { NavLink } from "react-router-dom"
import { setUserName } from "../../store/userReducer"
import EditUsernameDialog from "../dialog/auth/EditUsernameDialog"

export const AccountSidebar = () => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const user = useAppSelector((store) => store.user.user)

  const FireNav = styled(List)({
    "& .MuiListItemButton-root": {
      paddingLeft: 24,
      paddingRight: 24,
    },
    "& .MuiListItemIcon-root": {
      minWidth: 0,
      marginRight: 16,
    },
    "& .MuiSvgIcon-root": {
      fontSize: 22,
    },
  })

  const [openDepositDialog, closeDepositDialog] = useDialog()
  const [openWithdrawalDialog, closeWithdrawalDialog] = useDialog()
  const [openEditUsernameDialog, closeEditUsernameDialog] = useDialog()

  const onOpenEditUsernameDialog = (e) => {
    e.preventDefault()

    openEditUsernameDialog({
      children: (
        <EditUsernameDialog
          initialUsername={user.userName || ""}
          onClose={closeEditUsernameDialog}
          onSave={(username) => {
            dispatch(setUserName(username))
            closeEditUsernameDialog()
          }}
        />
      ),
    })
  }

  const onOpenDepositDialog = (e) => {
    e.preventDefault()
    openDepositDialog({
      children: <DepositDialog closeDialog={closeDepositDialog} width={480} />,
    })
  }

  const onOpenWithdrawalDialog = (e) => {
    e.preventDefault()
    openWithdrawalDialog({
      children: (
        <WithdrawalDialog closeDialog={closeWithdrawalDialog} width={480} />
      ),
    })
  }

  const [openMenu, setOpenMenu] = useState(true)

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 220,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: 220,
          boxSizing: "border-box",
        },
      }}
    >
      {/*<Toolbar sx={{ pt: 1, pb: 2, mx: "auto" }}>*/}
      {/*  <Logo />*/}
      {/*</Toolbar>*/}
      {/*<Divider />*/}
      <Box sx={{ display: "flex" }}>
        <FireNav component="nav" sx={{ maxWidth: 256 }}>
          <ListItem component="div" disablePadding>
            <ListItemButton
              sx={{ height: 48 }}
              component={NavLink}
              to={PATHS.ACCOUNT.PATH}
            >
              <ListItemIcon>
                <Home />
              </ListItemIcon>
              <ListItemText
                primary={`${user.address.substring(
                  0,
                  3,
                )}...${user.address.slice(-4)}`}
                primaryTypographyProps={{
                  fontSize: 18,
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem component="div" disablePadding>
            <ListItemButton
              sx={{
                height: 48,
                justifyContent: "flex-start",
              }}
              onClick={onOpenEditUsernameDialog}
            >
              <ListItemIcon>
                <Person />
              </ListItemIcon>
              <ListItemText
                primary={`${user.userName}`}
                primaryTypographyProps={{
                  fontSize: 18,
                }}
                sx={{
                  flex: "0 0 auto",
                }}
              />
              <ListItemIcon>
                <BorderColor
                  sx={{
                    width: 14,
                    ml: 2,
                  }}
                />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>

          <Divider />

          <Box sx={{ my: 1 }}>
            <ListItem component="div" disablePadding>
              <ListItemButton
                sx={{
                  py: 0,
                  cursor: "default",
                }}
                className="nav-link"
                disabled={true}
              >
                <ListItemText
                  primary={"Balances:"}
                  primaryTypographyProps={{ fontSize: 18 }}
                />
              </ListItemButton>
            </ListItem>

            <ListItem component="div" disablePadding>
              <ListItemButton
                sx={{
                  py: 0,
                  cursor: "default",
                }}
                className="nav-link"
              >
                <ListItemText
                  primary={
                    user.usdt.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) + " USDT"
                  }
                  primaryTypographyProps={{
                    fontSize: 18,
                    pl: 4,
                    lineHeight: 1,
                  }}
                />
              </ListItemButton>
            </ListItem>

            <ListItem component="div" disablePadding>
              <ListItemButton
                sx={{
                  py: 0,
                  cursor: "default",
                }}
                className="nav-link"
              >
                <ListItemText
                  primary={
                    user.ztd.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) + " ZTD"
                  }
                  primaryTypographyProps={{
                    fontSize: 18,
                    pl: 4,
                    lineHeight: 1,
                  }}
                />
              </ListItemButton>
            </ListItem>

            {user.lockedZtd > 0 && (
              <ListItem component="div" disablePadding>
                <ListItemButton
                  sx={{
                    py: 0,
                    cursor: "default",
                  }}
                  className="nav-link"
                  disabled={true}
                >
                  <ListItemText
                    primary={
                      "Locked: " +
                      user.lockedZtd.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) +
                      " ZTD"
                    }
                    primaryTypographyProps={{ fontSize: 18 }}
                  />
                </ListItemButton>
              </ListItem>
            )}
          </Box>

          <Divider />

          <AccountMenu
            title={"Account"}
            description={
              "Your Commanders, Turrets in the game, Boxes, Inventory"
            }
            menuList={[
              {
                PATH: PATHS.ACCOUNT.PATH,
                LABEL: PATHS.ACCOUNT.LABEL,
                ICON: <DashboardIcon />,
              },
              {
                PATH: PATHS.TRANSACTIONS.PATH,
                LABEL: PATHS.TRANSACTIONS.LABEL,
                ICON: <PaymentIcon />,
              },
              {
                PATH: PATHS.REFERAL.PATH,
                LABEL: PATHS.REFERAL.LABEL,
                ICON: <PeopleAltIcon />,
              },
              {
                TYPE: "divider",
              },
            ]}
          />

          <Divider />

          <AccountMenu
            title={"Operations"}
            description={"Operations: Withdrawal, Deposit and etc."}
            menuList={[
              {
                PATH: "/withdrawal",
                LABEL: "Withdrawal",
                ICON: <ArrowDownwardIcon />,
                ACTION: onOpenWithdrawalDialog,
                IS_DISABLED: true,
              },
              {
                PATH: "/deposit",
                LABEL: "Deposit",
                ICON: <ArrowUpwardIcon />,
                ACTION: onOpenDepositDialog,
                IS_DISABLED: true,
              },
              {
                PATH: "/sync-game",
                LABEL: "Sync Game",
                ICON: <SyncIcon />,
                IS_DISABLED: true,
              },
            ]}
          />
        </FireNav>
      </Box>
    </Drawer>
  )
}
